/*
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-04-19 10:15:35
 */
import request from '@/utils/service'

export function orderListApi(data) {
  return request({
    url: '/chargePieOrder/list',
    method: 'get',
    params: data
  })
}

export function listApi(data) {
  console.log('params :>> ', data)
  return request({
    url: '/business/list',
    method: 'get',
    params: data
  })
}

export function closeOrderApi(data) {
  return request({
    url: '/chargePieOrder/adminCloseOrder',
    method: 'post',
    data
  })
}

export function rechargeListApi(data) {
  return request({
    url: '/rechargeOrder/list',
    method: 'get',
    params: data
  })
}

export function chargeBackOrder(data) {
  return request({
    url: '/chargePieOrder/refundOrder',
    method: 'post',
    data
  })
}

export function exportOrder(data) {
  return request({
    url: '/chargePieOrder/exportExcel',
    method: 'get',
    params: data
  })
}

export function userWithdraw(data) {
  return request({
    url: '/userWithdraw/list',
    method: 'get',
    params: data
  })
}
